import type { CatalogNearMe, RelatedGeoArea } from './catalogsNearMe.types';

/**
 * Redux state slice for Auctions Near Me page
 *
 * Uses catalog-management API to fetch catalogs by geographic bounds.
 * API fetches use MAX_CATALOGS_TO_FETCH (1000) for client-side pagination.
 */
export type AuctionsNearMeSlice = {
    catalogIds: number[];
    catalogsNearMe: CatalogNearMe[];
    currentPage: number;
    error: string | null;
    loading: boolean;
    otherPlaces: RelatedGeoArea[];
    totalPages: number;
    totalRecords: number;
};

export const defaultAuctionsNearMeSlice: AuctionsNearMeSlice = {
    catalogIds: [],
    catalogsNearMe: [],
    currentPage: 0,
    error: null,
    loading: false,
    otherPlaces: [],
    totalPages: 0,
    totalRecords: 0,
};
